import FilterListIcon from "@mui/icons-material/FilterList";
import MonitorHeartRounded from "@mui/icons-material/MonitorHeartRounded";
import SettingsRounded from "@mui/icons-material/SettingsRounded";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useConnectionValidationStore } from "@store/connectionValidationStore";
import { useHubInstallStore } from "@store/hubInstallStore";
import classNames from "classnames";
import { useLocation } from "wouter";
import { useShallow } from "zustand/shallow";
import Octobuddy from "../assets/logo.svg?react";
import { ROUTES } from "../constants/routing";
import "./PageNav.css";
const navButtons = [
  {
    label: "Clarity",
    href: ROUTES.CLARITY,
    Icon: FilterListIcon,
  },
  {
    label: "System Health",
    href: ROUTES.SYSTEMHEALTH,
    Icon: MonitorHeartRounded,
  },
  {
    label: "Settings",
    href: ROUTES.SETTINGS,
    Icon: SettingsRounded,
  },
  // {
  //   label: "Support",
  //   href: ROUTES.SUPPORT,
  //   Icon: SupportRounded,
  // },
];

function getSystemHealthNavStatus({
  connectionStatus,
  hubInstalled,
}: {
  connectionStatus: ReturnType<
    typeof useConnectionValidationStore.getState
  >["connectionStatus"];
  hubInstalled?: boolean;
}) {
  if (hubInstalled === false) return "error";

  if (connectionStatus) {
    const connectionIsHealthy =
      connectionStatus.clientsConnected &&
      connectionStatus.receivingData &&
      connectionStatus.sendingData &&
      connectionStatus.dataIntegrity;

    if (!connectionIsHealthy) return "error";
    return "healthy";
  }

  return null;
}

export function PageNav() {
  const [location, setLocation] = useLocation();
  const hubInstalled = useHubInstallStore((state) => state.installed);
  const { connectionStatus } = useConnectionValidationStore(
    useShallow(({ connectionStatus }) => ({
      connectionStatus,
    })),
  );
  const systemHealthNavStatus = getSystemHealthNavStatus({
    connectionStatus,
    hubInstalled,
  });

  return (
    <Stack className="mdai-page-nav-container" gap={2}>
      <Button
        className="mdai-page-nav-header"
        variant="nav"
        key="Octant"
        onClick={() => setLocation(ROUTES.SPLASH)}
        startIcon={<Octobuddy />}
      >
        Octant
      </Button>
      {navButtons.map(({ label, href, Icon }) => (
        <Button
          className={classNames({
            active: href === location,
            splash: href === ROUTES.SPLASH,
          })}
          variant="nav"
          key={label}
          onClick={() => setLocation(href)}
          startIcon={<Icon />}
        >
          {label}
          {href === ROUTES.SYSTEMHEALTH && systemHealthNavStatus && (
            <Box
              component="span"
              className={classNames(
                "mdai-page-nav-status-dot",
                systemHealthNavStatus,
              )}
              aria-label={
                systemHealthNavStatus === "healthy"
                  ? "System health operational"
                  : "System health error"
              }
            />
          )}
        </Button>
      ))}
    </Stack>
  );
}
